import clsx from 'clsx';
import { getVehiclesByFilter } from 'features/vehicle/action';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrency } from 'utils/functionality';
import ClickOutside from '../ClickOutside';
import { resetDataVehicle } from 'features/vehicle/vehicleSlice';

const InputVehicleSuggestion = ({
  label,
  name,
  htmlFor,
  value, // state
  onChange, // setState
  onClick, // when choose dropdown
  className,
  style,
  placeholder,
  disable,
  payloadFilter,
  ...rest
}) => {
  const dispatch = useDispatch();
  const resetString = '';

  // GLOBAL STATE
  const { data: dataVehicle } = useSelector((state) => state.vehicle);

  // SHOW DROPDOWN FUNCTION
  const [isShowDropdown, setIsShowDropdown] = useState(false);

  // FIRST LOAD STATE
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  // SEARCH STATE
  const [isSearch, setIsSearch] = useState(false);

  // FILTER CAR STATE
  const [filteredCar, setFilteredCar] = useState([]);

  // IS LOADING WHEN SEARCH VEHICLE ACTIVE
  const [isLoadingSearchVehicle, setIsLoadingSearchVehicle] = useState(false);

  // FUNCTION WHEN CLICK DROPDOWN
  const handleClick = (item) => {
    onClick(item.id, resetString);
    setIsSearch(false);
    setIsShowDropdown(false);
  };

  // FUNCTION WHEN BLUR
  const handleBlur = () => {
    setTimeout(() => {
      setIsShowDropdown(false);
      setIsSearch(false);
    }, 200);
  };

  const handleFocus = () => {
    setIsShowDropdown(true);
  };

  const getStatusName = (status) => {
    switch (status) {
      case 'available':
        return 'Ready';
      case 'booked':
        return 'In Use';
      case 'locked':
        return 'In Repair';
      default:
        return '-';
    }
  };

  // FILTER CAR
  useEffect(() => {
    if ((!isSearch && value !== '' && typeof value === 'number') || isFirstLoad) return;

    if (value === '') dispatch(resetDataVehicle());

    if (value.length < 3) return;

    // debbounce
    const timeout = setTimeout(() => {
      if (!payloadFilter) return;

      dispatch(getVehiclesByFilter({ ...payloadFilter, name: value.toLowerCase() }));
      setIsLoadingSearchVehicle(true);
      setIsShowDropdown(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [value]);

  // SET FILTER CAR AFTER GET VEHICLE BY NAME
  useEffect(() => {
    setIsLoadingSearchVehicle(false);
    setFilteredCar(dataVehicle.vehicles);
  }, [dataVehicle]);

  return (
    <div className={clsx('select-field-car-suggestion', className)}>
      {label && (
        <label htmlFor={htmlFor} className="select-field-car-suggestion__label">
          {label}
        </label>
      )}
      <div
        style={{ width: '100%' }}
        className={
          disable ? 'select-field-car-suggestion__input-field disable' : 'select-field-car-suggestion__input-field'
        }
        tabIndex={!isSearch ? 0 : 1}
        onFocus={
          !isSearch
            ? () => {
                setIsFirstLoad(false);
                setIsSearch(true);
              }
            : () => {
                setIsFirstLoad(false);
              }
        }
        onBlur={isSearch ? () => {} : handleBlur}
      >
        <input
          autoFocus={!!(isSearch && !isFirstLoad)}
          id={htmlFor}
          type="text"
          placeholder={placeholder}
          name={name}
          style={style}
          className="select-field-car-suggestion__input-field__input"
          value={value}
          disabled={disable}
          onChange={onChange}
          onFocus={handleFocus}
          onBlur={() => {
            setIsSearch(false);
          }}
          {...rest}
        />
      </div>

      {/* DROPDOWN */}
      {isShowDropdown && !isLoadingSearchVehicle && (
        <ClickOutside onClickOutside={() => setIsShowDropdown(false)}>
          <ul className="select-field-car-suggestion__dropdown">
            {filteredCar?.map((item) => (
              <li key={item.id} className="list-car" data-id={item.id} onClick={() => handleClick(item)}>
                <h3>{`${item.brand_name} ${item.name}`}</h3>
                <p>
                  {item.year} | {item.category.name} | {setCurrency(item.price)} | {setCurrency(item.price_with_driver)}{' '}
                  | {getStatusName(item.status)} | {item.max_passanger?.toString().padStart(2, '0')}/
                  {item.max_suitcase?.toString().padStart(2, '0')} |{' '}
                  <span style={{ textTransform: 'capitalize' }}>{item.transmission}</span>
                </p>
              </li>
            ))}
          </ul>
        </ClickOutside>
      )}
    </div>
  );
};

export default InputVehicleSuggestion;
